import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCompanyByDealerCode } from '../api/portal/company.api';
import { logConsole, logTransaction } from '../common/log';
import { handleThunkError } from '../common/util';
import { LogType } from '../models/log.model';
import { ICompany } from '../models/portal/company.model';
import { ConfigName, updateConfigObject } from '../sqlite/common/config';
import { setIsLoadingCountState } from './appSlice';

interface ICompanyState {
  selectedCompany: ICompany | undefined;
  selectedCompanyLoading: boolean;
}

const initialState: ICompanyState = {
  selectedCompany: undefined,
  selectedCompanyLoading: false,
};

/// THUNKS

export const fetchCompanyByDealerCodeAsync = createAsyncThunk<{}, string>('company/fetchCompanyByDealerCodeAsync', async (dealerCode, { rejectWithValue, dispatch }) => {
  logTransaction(LogType.Info, `Fetching company by dealer code '${dealerCode}'`, '[company] fetchCompanyByDealerCodeAsync');
  try {
    dispatch(setIsLoadingCountState(1));
    dispatch(setSelectedCompanyLoadingState(true));
    const responseData = await getCompanyByDealerCode(dealerCode);
    dispatch(setSelectedCompanyState(responseData));
    dispatch(setIsLoadingCountState(-1));
    dispatch(setSelectedCompanyLoadingState(false));
    return responseData;
  } catch (err: any) {
    return handleThunkError(err, rejectWithValue, setIsLoadingCountState(-1), setSelectedCompanyLoadingState(false));
  }
});

export const setSelectedCompanyStoreAsync = createAsyncThunk<{}, ICompany>('company/setSelectedCompanyStoreAsync', async (company, { rejectWithValue, dispatch }) => {
  logTransaction(LogType.Info, `Setting selected company with code '${company.code}' (${company.name1}) to store`, '[company] setSelectedCompanyStoreAsync');
  try {
    dispatch(setSelectedCompanyState(company));
    await updateConfigObject<ICompany>(ConfigName.SelectedCompany, company, false);
  } catch (err: any) {
    return handleThunkError(err, rejectWithValue);
  }
});

/// SLICE

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setSelectedCompanyState: (state, action: PayloadAction<ICompany>) => {
      logConsole(LogType.Info, '[company] setSelectedCompanyState');
      state.selectedCompany = action.payload;
    },
    setSelectedCompanyLoadingState: (state, action: PayloadAction<boolean>) => {
      logConsole(LogType.Info, '[company] setSelectedCompanyLoadingState');
      state.selectedCompanyLoading = action.payload;
    },
  },
});

/// REDUCERS

export const { setSelectedCompanyState, setSelectedCompanyLoadingState } = companySlice.actions;

/// SELECTORS

// export const selectCompaniesSearchState = (state: RootState) => state.company.companiesSearch;

export default companySlice.reducer;
